export const EmployeeStatus = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  // DO_NOT_CONTACT: "do_not_contact",
};
